import React from 'react'
import css from './style.scss'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Collaborators from './collaborators'
import Lock from 'components/lock'
import Button from 'components/shared/button'
import store from 'utils/store'
import {push} from 'react-router-redux'
import api from './api'
class SettingsSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      hasMore:true,
      loading:false
    }
  }
  deleteAccount=()=>{
    if(window.confirm("Are you sure? You won't be able to access this account here in Stori anymore.")){
      api.deleteAccount(this.props.account.id).then(()=>{
        store.dispatch({type:"ADD_TOAST", message:"Account disconnected."})
        store.dispatch(push("/"))
      })
    }
  }
  pauseAccount=()=>{
    let message = "Are you sure you want to put this account on pause?"
    let when = new Date()
    let post_message = "This account is now on pause."
    if(this.props.account.paused_at){
      when = undefined
      post_message = "Starting now, this account will be synced again."
      message = "You are starting again this account. Are you sure?"
    }
    if(window.confirm(message)){
      api.pauseAccount(this.props.account.id, when).then((account)=>{
        console.log("account", account)
        let _account={}
        _account[account.id]=account
        store.dispatch({type:"ADD_ACCOUNT", payload:_account})
        store.dispatch({type:"ADD_TOAST", message:post_message})
      }).catch(e=>{
        store.dispatch({type:"ADD_TOAST", message:e.response.data.error})
      })
    }
  }
  openExport=()=>{
    if(this.props.user.subscription.active){
      store.dispatch(push("/a/"+this.props.account.id+"/download"))
    }else{
      store.dispatch({type:"OPEN_PREMIUM_MODAL"})
    }
  }
  render(){
    return (
      <Lock check={this.props.account.userRole==="creator"} redirect={"/a/"+this.props.account.id+"/"}>
        <div className={css.head}>
          <h3>Settings</h3>
          <div className={css.container}>
            <Collaborators account={this.props.account}/>
            <div className={css.general}>
              <h4>Export your data</h4>
              <p>You can export whenever you want the data from your account.</p>
              <Button primary className={css.exportButton} onClick={this.openExport}>export data</Button>
              {this.props.user.subscription.active &&
                <div>
                  <h4 className={css.delete}>Pause This Account</h4>
                  <p>If you pause an account we won't backup the new Instagram Stories, but you will be able to access the old stories as normal.<br/>
                    A paused account doesn't count on your accounts limit.</p>
                  <Button onClick={this.pauseAccount}>{this.props.account.paused_at ? "Start Sync Again" : "Pause Account"}</Button>
                </div>
              }
              <h4 className={css.delete}>Delete This Account</h4>
              <p>By deleting this account, you won't be able to access your stories and their stats here on Stori.<br/><b>We can't and won't delete any photo on your Instagram account.</b></p>
              <Button small onClick={this.deleteAccount}>Delete Account</Button>
            </div>
          </div>

        </div>
      </Lock>
    )
  }
}

const mapStateToProps = function (state, props) {
  let account=state.accounts[props.match.params.id]
  return {
    account,
    user:state.user.userData
  };
}

export default connect(mapStateToProps)(withRouter(SettingsSection));



// WEBPACK FOOTER //
// ./src/components/account_page/settings/index.js